import { render, staticRenderFns } from "./districtDisStatics.vue?vue&type=template&id=dd9e5b50&scoped=true"
import script from "./districtDisStatics.vue?vue&type=script&lang=js"
export * from "./districtDisStatics.vue?vue&type=script&lang=js"
import style0 from "./districtDisStatics.vue?vue&type=style&index=0&id=dd9e5b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9e5b50",
  null
  
)

export default component.exports